module.exports = __webpack_public_path__ + "img/noProfileImg.8ceb3ccb.jpg";